import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class ManageUsersService {

  private url: string = "http://localhost:8080/DDMF/ddmf_backoff/getall_user";
debugger;
  constructor(private http: Http) { }

  getUsers(){
    return this.http.get(this.url)
      .map(res => res.json());
      
  }

}



// WEBPACK FOOTER //
// ./src/app/manage-users/manage-users.service.ts